// src/hooks/useMyShop.js
// Хук возвращает данные текущего магазина (shop.my()).
// Глобальный кеш в памяти — чтобы не делать кучу вызовов с разных страниц.

import { useState, useEffect } from 'react';
import { shop as shopApi } from '../api';

let _cached = null;
let _loading = null;
const _listeners = new Set();

function notify() {
  _listeners.forEach(fn => fn(_cached));
}

async function _load() {
  if (_loading) return _loading;
  _loading = (async () => {
    try {
      _cached = await shopApi.my();
    } catch (e) {
      _cached = null;
    }
    _loading = null;
    notify();
    return _cached;
  })();
  return _loading;
}

// Принудительное обновление (например, после сохранения настроек)
export function refreshMyShop() {
  _cached = null;
  return _load();
}

// Установить shop напрямую (например, после updateExtras возвращает обновлённый)
export function setMyShop(shop) {
  _cached = shop;
  notify();
}

// Полностью очистить кэш (при выходе из аккаунта), чтобы следующий вход
// перечитал магазин заново и не показывал чужие/устаревшие данные.
export function clearMyShop() {
  _cached = null;
  _loading = null;
  notify();
}

export function useMyShop() {
  const [shop, setShop] = useState(_cached);

  useEffect(() => {
    _listeners.add(setShop);
    if (!_cached) _load();
    return () => { _listeners.delete(setShop); };
  }, []);

  return shop;
}

// Удобный хелпер: возвращает код валюты текущего магазина (или KGS по умолчанию).
export function useMyCurrency() {
  const shop = useMyShop();
  return shop?.currency || 'KGS';
}
